import cs_sources from './localization_resources_cs.json';

class LocalizationService {

  public localize(message: string): string {
    return (cs_sources as any)[message] ?? message;
  }
}

export default new LocalizationService();